function setAnchorStatus(status) {
    if (this.getSelectedMarker() instanceof this.libMap.OverlayView) {
        this.getSelectedMarker().setSelectedStatus(status);
    }
}

function isNewInfoWindow(marker) {
    return Odigeo._.isNull(this.infoWindow.getMap()) ||
        (!Odigeo._.isUndefined(this.infoWindow.getPosition()) &&
        this.getSelectedMarker().getPosition().lat() !== marker.getPosition().lat() &&
        this.getSelectedMarker().getPosition().lng() !== marker.getPosition().lng());
}

function onOpenNewInfo() {
    setAnchorStatus.call(this, true);
    this.libMap.event.trigger(this.getSelectedMarker(), 'changeIcon');
    this.refresh();
    this.libMap.event.trigger(this.infoWindow, 'loadedWindow', this.getSelectedMarker());
}

function onCloseNewInfo() {
    setAnchorStatus.call(this, false);
    this.libMap.event.trigger(this.getSelectedMarker() || {}, 'changeIcon');
    this.infoWindow.close();
    this.libMap.event.trigger(this.infoWindow, 'emptyWindow');
}

function getHtmlTemplate(dataMarker, mapConfig) {
    return this.template(this.parser.getRenderData(dataMarker, mapConfig));
}

function InfoCommon(map, libMap, options) {
    this.libMap = libMap;
    this.map = map;
    this.template = options.template;
    this.parser = options.parser;
}

InfoCommon.prototype.getSelectedMarker = function() {
    return this.infoWindow.getAnchor();
};

InfoCommon.prototype.hasElement = function(el) {
    return Odigeo._.isElement(this.getDiv()) && $(this.getDiv()).find(el).length !== 0;
};

InfoCommon.prototype.bindCommonEvents = function() {
    this.libMap.event.addListener(this.infoWindow, 'closeWindow', Odigeo._.bind(onCloseNewInfo, this));
    this.libMap.event.addListener(this.infoWindow, 'domready', Odigeo._.bind(onOpenNewInfo, this));
};

InfoCommon.prototype.getInfoWindow = function() {
    return this.infoWindow;
};

InfoCommon.prototype.update = function(marker, mapConfig) {
    this.libMap.event.trigger(this.infoWindow, 'closeWindow');
    this.infoWindow.setContent(getHtmlTemplate.call(this, marker.dataMarker, mapConfig));
    this.infoWindow.open(this.map, marker);
};

InfoCommon.prototype.toggle = function(marker, mapConfig) {
    if (isNewInfoWindow.call(this, marker)) {
        this.update(marker, mapConfig);
    } else {
        this.refresh();
    }
};

InfoCommon.prototype.setCommonOptions = function(options) {
    this.infoWindow.setOptions(this.getDefaultOptions(options));
};

module.exports = InfoCommon;
